var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#green-checked_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 12.857,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#10B981",
  fillRule: "evenodd",
  d: "M18 0c9.94 0 18 8.06 18 18s-8.06 18-18 18S0 27.94 0 18 8.06 0 18 0m-3.738 23.846-4.407-4.41a1.933 1.933 0 0 1 0-2.727 1.936 1.936 0 0 1 2.727 0l3.107 3.109 7.729-7.729a1.93 1.93 0 0 1 2.727 0c.751.751.75 1.977 0 2.727l-9.094 9.095a1.933 1.933 0 0 1-2.789-.065",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "green-checked_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgGreenChecked;